import Vue from "vue";

export const $rules = {
    required: (message = "Campo obrigatório") => {
        return v => !!v || message;
    },
}

Vue.prototype.$rules = $rules;